
export default {
	name: 'UnitTextField',
	model: { prop: 'value', event: 'update:value' },
	props: {
		items: { type: Array, default: () => [] },
		value: { type: Object, default: null },
	},
	data () {
		return {
			CHEVRON_ICON:
			`<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="24" viewBox="0 0 512 512">
				<g transform="scale(1, -1) translate(0, -460)">
					<path data-glyph="chevron-down" fill="currentColor" d="M158 265l98 -98l98 98l30 -30l-128 -128l-128 128z" />
				</g>
			</svg>`,
			unitMenuState: false,
			lazyValue: { unit: null, amount: null },
			searchText: '',
			filterText: '',
		};
	},
	computed: {
		selectFilteredItems ()
		{
			if(!this.filterText) return this.items;
			return this.items.filter(item => (item.text.includes(this.filterText.toUpperCase())));
		},
		selectedItem ()
		{
			if(this.lazyValue.unit) return this.items.find(itm => (itm.value == this.lazyValue.unit));
		},
	},
	watch: {
		value: {
			handler (v)
			{
				if(typeof v == 'object'){
					if(v === null){
						this.setUnit(null);
						this.setAmount(null);
					}else{
						if('unit' in v) this.setUnit(v.unit);
						if('amount' in v) this.setAmount(v.amount);
					}
				}
			},
			deep: true,
			immediate:  true,
		},
		lazyValue: {
			handler (v) { this.$emit('update:value', this.lazyValue); },
			deep: true,
		},
		items (v)
		{
			if(v.length == 0) this.setUnit(null);
		},
	},
	methods: {
		setUnit (unit)
		{
			if(unit === null){
				this.lazyValue.unit = null;
				this.searchText = '';
				this.filterText = '';
				this.setAmount(null);
			}else{
				if(typeof unit == 'string') unit = this.items.findIndex(itm => (itm.value == unit));
				if(typeof unit == 'number' && unit >= 0 && unit < this.items.length){
					this.lazyValue.unit = this.items[unit].value;
					this.searchText = this.items[unit].text;
					this.filterText = '';
				}else{
					this.lazyValue.unit = null;
					this.searchText = '';
					this.filterText = '';
				}
			}
		},
		setAmount (amount)
		{
			if(amount == null){
				this.lazyValue.amount = null;
			}else{
				this.lazyValue.amount = String(amount);
			}
		},
		selectChanged ()
		{
			if(this.selectedItem) this.setUnit(this.selectedItem.value);
			else this.setUnit(null);
		},
		applyFilter ()
		{
			this.filterText = this.searchText;
			this.unitMenuState = true;
		},
	},
}
